const WISHLIST_KEY = 'shopify_wishlist';

// Custom money formatting function
function formatMoney(cents) {
  if (cents == null) return '$0.00';
  let num = parseFloat(cents);
  if (isNaN(num)) {
    // Try to clean if string
    if (typeof cents === 'string') {
      let clean = cents.replace(/[^0-9.-]/g, '');
      num = parseFloat(clean);
    }
    if (isNaN(num)) return '$0.00';
  }
  const dollars = (num / 100).toFixed(2);
  return `$${dollars}`;
}

// Get wishlist from localStorage
function getWishlist() {
  const wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  // Migrate old wishlist items to ensure inventory_quantity exists
  const migratedWishlist = wishlist.map(item => ({
    ...item,
    inventory_quantity: item.inventory_quantity !== undefined ? parseInt(item.inventory_quantity) || 0 : 0
  }));
  return migratedWishlist;
}

// Save wishlist to localStorage
function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
}

// Toggle item in wishlist
function toggleWishlist(handle, id, title, image, price, sku, inventory_quantity) {
  let wishlist = getWishlist();
  const index = wishlist.findIndex(item => item.handle === handle);
  // Validate inventory_quantity
  const quantity = isNaN(parseInt(inventory_quantity)) ? 0 : parseInt(inventory_quantity);
  // Ensure price is a valid number (already in cents from Shopify)
  const validPrice = isNaN(parseInt(price)) ? 0 : parseInt(price);
  if (index === -1) {
    wishlist.push({ handle, id, title, image, price: validPrice, sku, inventory_quantity: quantity });
  } else {
    wishlist.splice(index, 1);
  }
  saveWishlist(wishlist);
  updateWishlistButtons();
  if (window.location.pathname.toLowerCase() === '/pages/wishlist') {
    displayWishlist();
  }
}

// Update button states on product pages
function updateWishlistButtons() {
  const buttons = document.querySelectorAll('.wishlist-button');
  buttons.forEach(btn => {
    const handle = btn.dataset.productHandle;
    const wishlist = getWishlist();
    if (wishlist.some(item => item.handle === handle)) {
      btn.classList.add('added');
      btn.querySelector('#wishlist-text').textContent = 'Remove from Wish List';
    } else {
      btn.classList.remove('added');
      btn.querySelector('#wishlist-text').textContent = 'Add to Wish List';
    }
  });
}

// Display wishlist on wish-list page
function displayWishlist() {
  const wishlistBlock = document.querySelector('.js-wishlistBlock');
  const emptyMessage = document.getElementById('empty-wishlist');
  if (!wishlistBlock) {
    return;
  }
  if (!emptyMessage) {
    return;
  }

  wishlistBlock.innerHTML = '';
  const wishlist = getWishlist();
  if (wishlist.length === 0) {
    emptyMessage.style.display = 'block';
    wishlistBlock.style.display = 'none';
    return;
  }
  emptyMessage.style.display = 'none';
  wishlistBlock.style.display = 'grid';

  // Get current column count from active toolbar icon
  const activeToolbarIcon = document.querySelector('.toolbar-icon.active');
  const currentColCount = activeToolbarIcon ? activeToolbarIcon.dataset.col : '3'; // default to 3 columns

  wishlist.forEach(item => {
    const div = document.createElement('div');
    div.className = `c-product col-${currentColCount}`;
    // Format availability based on inventory_quantity
    const availabilityText = item.inventory_quantity > 0 
      ? `Estimated number that can be made: ${item.inventory_quantity} item(s)` 
      : 'Out of Stock';
    const availabilityClass = item.inventory_quantity > 0 ? '' : 'out-of-stock';
    div.innerHTML = `
      <div class="wishlist-product-grid">
        <div class="product-info">
          <a href="/products/${item.handle}">
            <img src="${item.image || '//via.placeholder.com/200'}" alt="${item.title || 'Product'}">
          </a>
          <button class="delete-btn" onclick="removeFromWishlist('${item.handle}')">X</button> 
        </div>
        <div class="product-info">
          <div class="product-info-top">
            <h3>${item.title || 'Unknown Product'}</h3>
            <p class="availability ${availabilityClass}">${availabilityText}</p>
            <p class="price">${formatMoney(item.price || 0)}</p>
          </div>
          <a class="button product-link" href="/products/${item.handle}">See Details</a>
        </div>
      </div>
    `;
    wishlistBlock.appendChild(div);
  });
}

// Remove specific item
function removeFromWishlist(handle) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter(item => item.handle !== handle);
  saveWishlist(wishlist);
  displayWishlist();
  updateWishlistButtons();
}

// Adjust column count based on toolbar icons
function adjustColumns() {
  const toolbarIcons = document.querySelectorAll('.toolbar-icon');
  if (!toolbarIcons.length) {
    return;
  }
  toolbarIcons.forEach(icon => {
    icon.addEventListener('click', () => {
      const colCount = icon.dataset.col;
      
      // Update grid template columns
      document.querySelector('.js-wishlistBlock').style.gridTemplateColumns = `repeat(${colCount}, 1fr)`;
      
      // Update column classes on all product items
      const productItems = document.querySelectorAll('.js-wishlistBlock .c-product');
      productItems.forEach(item => {
        // Remove existing col-* classes
        item.className = item.className.replace(/\bcol-\d+\b/g, '');
        // Add new col class
        item.classList.add(`col-${colCount}`);
      });
      
      // Update active class on toolbar icons
      toolbarIcons.forEach(i => i.classList.remove('active'));
      icon.classList.add('active');
    });
  });
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistButtons();
  if (window.location.pathname.toLowerCase() === '/pages/wishlist') {
    displayWishlist();
    adjustColumns();
  }
  // Attach event to buttons
  document.querySelectorAll('.wishlist-button').forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.productHandle;
      const id = btn.dataset.productId;
      const title = btn.dataset.productTitle;
      const image = btn.dataset.productImage;
      // Fixed price parsing: data-product-price is already in cents from Shopify {{ product.price }}
      const price = parseInt(btn.dataset.productPrice) || 0;
      const sku = btn.dataset.productSku;
      const inventory_quantity = btn.dataset.productInventoryQuantity;
      toggleWishlist(handle, id, title, image, price, sku, inventory_quantity);
    });
  });
});

/* ------------------------------------ */
 
// Initialize compare list from local storage
let compareList = JSON.parse(localStorage.getItem('compareList')) || [];

// Helper function to decode HTML entities
function decodeHtml(html) {
  try {
    if (typeof html !== 'string') {
      return '';
    }
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    const decoded = txt.value;
    return decoded;
  } catch (error) {
    return '';
  }
}

// Function to set button state based on whether product is added
function setButtonState(button, isAdded) {
  try {
    const buttonText = button.querySelector('.compare-button-text');
    if (isAdded) {
      button.classList.add('added');
      if (buttonText) buttonText.textContent = 'Remove from Compare';
    } else {
      button.classList.remove('added');
      if (buttonText) buttonText.textContent = 'Add to Compare';
    }
  } catch (error) {
  }
}

// Function to update all compare buttons based on compareList
function updateCompareButtons() {
  try {
    const compareButtons = document.querySelectorAll('.add-to-compare');
    compareButtons.forEach(button => {
      try {
        const productData = button.dataset.product;
        const product = JSON.parse(productData);
        const isAdded = compareList.some(item => String(item.id) === String(product.id));
        setButtonState(button, isAdded);
      } catch (error) {
      }
    });
  } catch (error) {
  }
}

// Function to show success feedback on button
function showSuccessOnButton(button, message) {
  try {
    const buttonText = button.querySelector('.compare-button-text');
    if (buttonText) {
      buttonText.textContent = message;
    }
    button.classList.add('success');
    button.disabled = true;

    // Revert button state after 3 seconds to the correct persistent state
    setTimeout(() => {
      const productData = button.dataset.product;
      const product = JSON.parse(productData);
      const isAdded = compareList.some(item => String(item.id) === String(product.id));
      setButtonState(button, isAdded);
      button.classList.remove('success');
      button.disabled = false;
    }, 3000);
  } catch (error) {
  }
}

// Function to show error feedback on button
function showErrorOnButton(button, message) {
  try {
    const buttonText = button.querySelector('.compare-button-text');
    if (buttonText) {
      buttonText.textContent = message;
    }
    button.classList.add('error');
    button.disabled = true;

    // Revert button state after 3 seconds to the correct persistent state
    setTimeout(() => {
      const productData = button.dataset.product;
      const product = JSON.parse(productData);
      const isAdded = compareList.some(item => String(item.id) === String(product.id));
      setButtonState(button, isAdded);
      button.classList.remove('error');
      button.disabled = false;
    }, 3000);
  } catch (error) {
    alert(message); // Fallback to alert
  }
}

// Function to show comparison popup
function showComparePopup() {
  try {
    // Remove existing popup if any
    const existingPopup = document.querySelector('.compare-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    // Create popup elements
    const popup = document.createElement('div');
    popup.className = 'compare-popup';

    // Generate table for comparison
    const tableHtml = compareList.length > 0
      ? `
        <table class="compare-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>SKU</th>
              <th>Description</th>
              <th>Collection</th>
              <th>Availability</th>
            </tr>
          </thead>
          <tbody>
            ${compareList.map(product => `
              <tr class="product-row" data-product-id="${product.id}">
                <td class="compare-table-product">
                  <div class="compare-image">
                    <button class="remove-compare" data-id="${product.id}">&times;</button>
                    <a href="${product.url || '#'}" target="_blank">
                      <img src="${product.image || 'https://placehold.co/360x360'}" alt="${product.title || 'Product'}" class="product-image" width="100" height="100" loading="lazy" onerror="this.src='https://placehold.co/360x360';">
                    </a>
                    <div class="product-title">${product.title || ''}</div>
                    <!-- <div class="product-price">${formatMoney(product.price || 0)}</div> -->
                  </div>
                </td>
                <td>${product.partNumber || ''}</td>
                <td class="product-decription">
                  <div class="decription">
                    ${product.description !== undefined ? product.description.replace(/\\n/g, '<br>').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"') : 'No description'}
                  </div>
                </td>
                <td>${product.collection || ''}</td>
                <td>${product.availability ? 'In Stock' : 'Out of Stock'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `
      : '<div class="no-products">No products to compare yet.</div>';

    popup.innerHTML = `
      <div class="compare-popup__content">
        <h4 class="compare-title">Compare</h4>
        <div class="compare-table-container">${tableHtml}</div>
        <div class="button-row">
          <button class="compare-popup__close btn">X</button>
          <button class="clear-compare btn">Clear All</button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    // Close popup on button click
    const closeButton = popup.querySelector('.compare-popup__close');
    closeButton.addEventListener('click', () => {
      popup.remove();
    });

    // Clear all products on clear button click
    const clearButton = popup.querySelector('.clear-compare');
    if (clearButton) {
      clearButton.addEventListener('click', () => {
        clearCompareList();
        popup.remove();
      });
    }

    // Handle remove buttons in compare popup
    popup.querySelectorAll('.remove-compare').forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = button.dataset.id;
        compareList = compareList.filter(item => String(item.id) !== String(id));
        localStorage.setItem('compareList', JSON.stringify(compareList));
        updateCompareCount();
        updateCompareButtons(); // Update buttons after removal
        showComparePopup(); // Refresh popup
      });
    });

    // Close popup on outside click
    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        popup.remove();
      }
    });
  } catch (error) {
    alert('Error displaying comparison list.');
  }
}

// Debounce utility to limit function calls
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Function to update comparison count
function updateCompareCount() {
  try {
    const countElements = document.querySelectorAll('.compare-count');
    if (countElements.length === 0) {
      // Retry after a short delay if no elements are found
      setTimeout(updateCompareCount, 500);
      return;
    }
    countElements.forEach(element => {
      element.textContent = compareList.length;
    });
  } catch (error) {
  }
}

// Function to add product to comparison
function addToCompare(product, button) {
  try {
    if (!product.id) {
      showErrorOnButton(button, 'Invalid Data');
      return;
    }
    if (compareList.some(item => String(item.id) === String(product.id))) {
      showErrorOnButton(button, 'Already Added');
      return;
    }
    if (compareList.length >= 5) {
      showErrorOnButton(button, 'Max Reached');
      return;
    }
    // Validate and preserve description
    const validatedProduct = { ...product }; // Create a copy
    if (validatedProduct.description === undefined) validatedProduct.description = 'No description';
    // Fixed price parsing: price from data-product is {{ product.price }} in cents
    validatedProduct.price = parseInt(validatedProduct.price) || 0;
    compareList.push(validatedProduct);
    localStorage.setItem('compareList', JSON.stringify(compareList));
    updateCompareCount(); // Explicitly update count after adding
    updateCompareButtons(); // Update all buttons
    showSuccessOnButton(button, 'Added!'); // Show success feedback
  } catch (error) {
    showErrorOnButton(button, 'Error');
  }
}

// Function to clear comparison list
function clearCompareList() {
  try {
    compareList = [];
    localStorage.removeItem('compareList');
    updateCompareCount();
    updateCompareButtons(); // Update all buttons to not added

    // Reset all compare buttons to their original state (redundant but safe)
    document.querySelectorAll('.add-to-compare').forEach(button => {
      const buttonText = button.querySelector('.compare-button-text');
      if (buttonText) {
        buttonText.textContent = 'Add to Compare';
      }
      button.classList.remove('added', 'error', 'success');
      button.disabled = false;
    });
  } catch (error) {
  }
}

// Initialize comparison functionality
const initializeCompare = debounce(() => {
  try {
    updateCompareCount();
    updateCompareButtons(); // Update button states on init

    // Initialize add-to-compare buttons
    const compareButtons = document.querySelectorAll('.add-to-compare');
    compareButtons.forEach(button => {
      button.removeEventListener('click', handleAddToCompare);
      button.addEventListener('click', handleAddToCompare);
    });

    // Initialize clear-compare button
    const clearCompareButton = document.querySelector('.clear-compare');
    if (clearCompareButton) {
      clearCompareButton.removeEventListener('click', clearCompareList);
      clearCompareButton.addEventListener('click', clearCompareList);
    }
  } catch (error) {
  }
}, 100);

// Handle add to compare click
function handleAddToCompare(event) {
  try {
    const button = event.currentTarget;
    const productData = button.dataset.product;
    const product = JSON.parse(productData);
    addToCompare(product, button);
  } catch (error) {
    showErrorOnButton(event.currentTarget, 'Error');
  }
}

// Handle view-compare clicks via event delegation
function setupEventDelegation() {
  document.removeEventListener('click', handleViewCompareClick);
  document.addEventListener('click', handleViewCompareClick);
}

function handleViewCompareClick(event) {
  const button = event.target.closest('.view-compare');
  if (button) {
    showComparePopup();
  }
}

// Retry initialization for dynamic elements
function retryInitialization() {
  let attempts = 0;
  const maxAttempts = 10;
  const interval = setInterval(() => {
    const viewCompareButton = document.querySelector('.view-compare');
    const countElements = document.querySelectorAll('.compare-count');
    
    if (countElements.length > 0 || attempts >= maxAttempts) {
      clearInterval(interval);
      initializeCompare();
      updateCompareCount();
    }
    attempts++;
  }, 1500); // Increased interval to 1.5 seconds
}

// Observe DOM for .compare-count elements
function observeCompareCount() {
  const observer = new MutationObserver(() => {
    const countElements = document.querySelectorAll('.compare-count');
    if (countElements.length > 0) {
      updateCompareCount();
      observer.disconnect(); // Stop observing once found
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Run initialization on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeCompare();
  setupEventDelegation();
  retryInitialization();
  observeCompareCount();
});

// Handle dynamic navigation
document.addEventListener('shopify:section:load', () => {
  initializeCompare();
  setupEventDelegation();
  updateCompareCount(); // Ensure count updates
  retryInitialization();
});

document.addEventListener('shopify:block:select', () => {
  initializeCompare();
  setupEventDelegation();
  updateCompareCount(); // Ensure count updates
  retryInitialization();
});

window.addEventListener('popstate', () => {
  initializeCompare();
  setupEventDelegation();
  updateCompareCount(); // Ensure count updates
  retryInitialization();
});